import { GridColumn } from '@/@types'
import { UserScope } from '@/models/users'

const gridColumns: GridColumn[] = [
  {
    name: 'status',
    show: true,
    width: '2rem',
    sortable: true,
    title: 'common.status',
    label: '•',
    type: 'Status',
    scope: UserScope.ScriptsEdit,
    test: false,
  },
  {
    name: 'id',
    show: true,
    width: '4rem',
    sortable: true,
    title: 'script.numberTooltip',
    label: '№',
    type: 'Number',
    scope: UserScope.ScriptsView,
    test: false,
  },
  {
    name: 'title',
    show: true,
    width: '1fr',
    sortable: true,
    title: 'script.nameTooltip',
    label: 'script.name',
    type: 'String',
    scope: UserScope.ScriptsView,
    test: false,
  },
  {
    name: 'steps',
    show: true,
    width: '4.5rem',
    sortable: true,
    title: 'script.stepsTooltip',
    label: 'script.steps',
    type: 'Number',
    scope: UserScope.ScriptsEdit,
    test: false,
  },
  {
    name: 'duration',
    show: true,
    width: '8rem',
    sortable: true,
    title: 'script.durationTooltip',
    label: 'script.duration',
    type: 'Duration',
    scope: UserScope.ScriptsEdit,
    test: false,
  },
  {
    name: 'pass',
    show: true,
    width: '8rem',
    sortable: true,
    title: 'script.finishesTooltip',
    label: 'script.finishes',
    type: 'Number',
    scope: UserScope.ScriptsEdit,
    test: true,
  },
  {
    name: 'target',
    show: true,
    width: '5.5rem',
    sortable: true,
    title: 'script.targetsTooltip',
    label: 'script.targets',
    type: 'Number',
    scope: UserScope.ScriptsEdit,
    test: true,
  },
  {
    name: 'conversion',
    show: true,
    width: '6rem',
    sortable: true,
    title: 'script.conversionTooltip',
    label: 'script.conversion',
    type: 'Number',
    scope: UserScope.ScriptsEdit,
    test: true,
  },
  {
    name: 'menu',
    show: true,
    width: '4.5rem',
    sortable: false,
    title: '',
    label: '',
    type: 'Menu',
    scope: UserScope.ScriptsView,
    test: false,
  },
  {
    name: 'buttons',
    show: true,
    width: '12rem',
    sortable: false,
    title: '',
    label: '',
    type: 'Button',
    scope: UserScope.ScriptsView,
    test: false,
  },
]

export default gridColumns
